import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import  { Navbar } from '../../global/Navbar/Navbar.component';
import { SocketService } from '../../core/websocket/socket.service';


@Component({
  selector:'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  imports: [Navbar, RouterModule,CommonModule]
})

export class MainLayoutComponent {

  private socketService = inject(SocketService);

  constructor() {

    
    this.socketService.connect();
  } 
}